"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatInternationalDate = void 0;
const zeroPad = (x) => x.toString().padStart(2, '0');
const formatInternationalDate = (date) => {
    if (date == null) {
        return '';
    }
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    return `${year}-${zeroPad(month)}-${zeroPad(day)}`;
};
exports.formatInternationalDate = formatInternationalDate;
//# sourceMappingURL=formatInternationalDate.js.map